import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "./api";

export const SERIES_SEO = {
  all: { seo_title: "Archive — RCKT", seo_description: "The RCKT archive documents an ongoing artistic practice through numbered works across Genesis, Explorations, Objects and Field." },
  genesis: { seo_title: "Genesis — RCKT Archive", seo_description: "Genesis is the foundational series within the RCKT archive, documenting the beginnings of an ongoing artistic practice." },
  explorations: { seo_title: "Explorations — RCKT Archive", seo_description: "Explorations is a series within the RCKT archive investigating writing, marks, repetition, form and visual interpretation." },
  objects: { seo_title: "Objects — RCKT Archive", seo_description: "Objects documents physical works and objects within the ongoing RCKT artistic practice." },
  field: { seo_title: "Field — RCKT Archive", seo_description: "Field documents RCKT works made through observation, intervention and engagement with the environments around them." },
};

export const absUrl = (p) => {
  if (!p) return undefined;
  return p.startsWith("http") ? p : `${window.location.origin}${p}`;
};

export function usePageSeo(key) {
  const [seo, setSeo] = useState(null);
  useEffect(() => { api.get(`/pages/${key}`).then((r) => setSeo(r.data)).catch(() => {}); }, [key]);
  return seo;
}

export default function Seo({ title, description, canonical, image, noindex = false, type = "website", jsonLd }) {
  const fullTitle = title || "RCKT — Artistic Practice & Archive";
  const img = absUrl(image);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:site_name" content="RCKT" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {img && <meta name="twitter:image" content={img} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
